let parser = new DOMParser();
class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
  }

  initLoadMore() {
    const count = document
      .getElementById("load-more-container")
      .getAttribute("data-count");
    this.querySelectorAll(".actions-load-more").forEach((loadMore) => {
      var _this = this;
      if (loadMore.classList.contains("infinit-scrolling")) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                _this.loadMorePosts(loadMore, count);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMore);
      } else {
        loadMore.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMorePosts(target, count);
          },
          false
        );
      }
    });
  }

  loadMorePosts(target, count) {
    const loadMore_url = target.getAttribute("href");
    const _this = this;
    _this.toggleLoading(target, true);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const resultNodes = parser.parseFromString(responseText, "text/html");
        const resultNodesHtml = resultNodes.querySelectorAll(
          "#main-items .item-load"
        );
        resultNodesHtml.forEach((prodNode) =>
          document
            .getElementById("section__content-items")
            .appendChild(prodNode)
        );

        const images = document.querySelectorAll("#section__content-items img");
        images.forEach((img) => {
          if (img.hasAttribute("data-srcset")) {
            img.setAttribute("srcset", img.getAttribute("data-srcset"));
            img.removeAttribute("data-srcset");
          }
        });

        const load_more = resultNodes.querySelector(".actions-load-more");
        document.querySelector(".load-more-amount").innerHTML =
          resultNodes.querySelector(".load-more-amount").textContent;
        if (load_more) {
          target.setAttribute("href", load_more.getAttribute("href"));
        } else {
          target.remove();
        }
        _this.updateProgressBar(count);
        _this.toggleLoading(target, false);
      })
      .catch((error) => {
        throw error;
      });
  }

  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? "add" : "remove";
      event.classList[method]("loading");
    }
  }

  updateProgressBar(count) {
    var amount = document.querySelectorAll(
      "#section__content-items .item-load"
    ).length;
    var percent = (amount / count) * 100;
    var progressBar = document.querySelector(".load-more-progress-bar");
    progressBar.style.setProperty("--percent", percent + "%");
    progressBar.style.setProperty("--amount", amount);
  }
}

customElements.define("loadmore-button", PaginateLoadmore);

class LoadMoreButtonCollection extends HTMLElement {
  constructor() {
    super();
    this.loadMoreButton = this.querySelector("a");
    this.loadMoreElement = document.querySelector(".actions-load-more");
    this.init();
  }

  init() {
    if (!this.loadMoreButton) return;
    
    this.loadMoreButton.addEventListener("click", this.handleClick.bind(this));
    this.loadMoreButton.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    this.executeLoadMore();
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.executeLoadMore();
    }
  }

  executeLoadMore() {
    this.toggleLoading(true);
    
    setTimeout(() => {
      this.showHiddenCollections();
      this.toggleLoading(false);
      this.cleanup();
    }, 500);
  }

  toggleLoading(isLoading) {
    if (this.loadMoreElement) {
      this.loadMoreElement.classList.toggle("loading", isLoading);
    }
    
    if (this.loadMoreButton) {
      this.loadMoreButton.classList.toggle("loading", isLoading);
    }
  }

  showHiddenCollections() {
    const hiddenItems = document.querySelectorAll(
      ".section__collections-list .collection-item.hidden"
    );
    
    hiddenItems.forEach((item) => {
      item.classList.remove("hidden");
    });
  }

  cleanup() {
    this.remove();
  }
}

customElements.define("loadmore-button-collection", LoadMoreButtonCollection);

class AjaxPagination extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.init();
  }

  init() {
    this.querySelectorAll('.pagination-ajax-link').forEach((link) => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const url = link.getAttribute('href');

    if (!url) return;

    this.loadPage(url);
  }

  loadPage(url) {
    const container = document.getElementById('ProductsGridContainer');
    const collectionGrid = document.getElementById('CollectionGird');

    if (container) {
      container.classList.add('loading');
    }

    // Scroll verso l'alto della griglia prodotti
    const scrollTarget = container || collectionGrid;
    if (scrollTarget) {
      const offsetTop = scrollTarget.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    // Costruisci URL con section_id per ottenere solo la sezione
    const fetchUrl = this.buildSectionUrl(url);

    fetch(fetchUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        const htmlDoc = parser.parseFromString(html, 'text/html');

        // Aggiorna la griglia dei prodotti
        if (collectionGrid) {
          const newGrid = htmlDoc.getElementById('CollectionGird');
          if (newGrid) {
            collectionGrid.innerHTML = newGrid.innerHTML;
          }
        }

        // Aggiorna URL nel browser senza ricaricare
        history.pushState({}, '', url);

        // Reinizializza lazy loading per le nuove immagini
        this.reinitLazyLoad();

        // Rimuovi classe loading
        if (container) {
          container.classList.remove('loading');
        }
      })
      .catch((error) => {
        console.error('Pagination error:', error);
        if (container) {
          container.classList.remove('loading');
        }
        // Fallback: naviga normalmente in caso di errore
        window.location.href = url;
      });
  }

  buildSectionUrl(url) {
    const urlObj = new URL(url, window.location.origin);
    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid ? productGrid.dataset.id : this.sectionId;

    if (sectionId) {
      urlObj.searchParams.set('section_id', sectionId);
    }

    return urlObj.toString();
  }

  reinitLazyLoad() {
    const images = document.querySelectorAll('#CollectionGird img[data-srcset]');
    images.forEach((img) => {
      if (img.hasAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      }
    });

    // Trigger lazy loader se disponibile
    if (typeof LazyLoader !== 'undefined') {
      new LazyLoader('.image-lazy-load');
    }
  }
}

customElements.define('ajax-pagination', AjaxPagination);
